import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import { useUpdateMyList as useUpdateAansluitingMyList } from '../../aansluiting/project/hooks/useUpdateMyList'
import { useUpdateMyList as useUpdateHoofdleidingMyList } from '../../hoofdleiding/project/hooks/useUpdateMyList'

import { MyListIcon } from './MyListIcon'

type Props = {
  type: 'hoofdleiding' | 'aansluiting'
  active?: boolean
  disabled?: boolean
  aanvraagID: string
  asButton?: false
  size?: number
  sx?: undefined
}

export const MyListButton = ({
  aanvraagID,
  active = false,
  disabled = false,
  type,
}: Props) => {
  const { mutate: updateAansluitingList } = useUpdateAansluitingMyList()
  const { mutate: updateHoofdleidingList } = useUpdateHoofdleidingMyList()

  const handleClick = () => {
    if (type === 'hoofdleiding') {
      updateHoofdleidingList({
        aanvraagID,
        method: active ? 'remove' : 'add',
      })
    }

    if (type === 'aansluiting') {
      updateAansluitingList({
        aanvraagID,
        method: active ? 'remove' : 'add',
      })
    }
  }

  /** Materal UI does not like tooltips around a disabled button. */
  if (disabled) {
    return (
      <IconButton disabled={disabled}>
        <MyListIcon active={active} />
      </IconButton>
    )
  }

  return (
    <Tooltip
      title={active ? 'Verwijderen van mijn lijst' : 'Toevoegen aan mijn lijst'}
    >
      <IconButton onClick={handleClick}>
        <MyListIcon active={active} />
      </IconButton>
    </Tooltip>
  )
}
